import { Text } from "@zapier/design-system";
import styles from "./EditingGlow.module.css";

/** Works with a parent that has position: relative */
export default function EditingGlow() {
  return (
    <div className={styles.selectedGlow}>
      <span className={styles.editing}>
        <span className={styles.textWrapper}>
          <Text type="SmallPrint3" color="PrimeWhite">
            Editing
          </Text>
        </span>
      </span>
    </div>
  );
}
